import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
export function InternalServer() {
    const navigate = useNavigate();
    return (_jsx(Result, { status: '500', title: '500', subTitle: 'Sorry, something went wrong.', extra: _jsx(Button, { type: 'primary', onClick: () => navigate('/signout-oidc'), children: "Sign out" }) }));
}
